<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-4">
        <h1 class="display-1 font-weight-medium mb-3">
          Bienvenue sur mon site de la coupe du monde
        </h1>

        <p class="subheading font-weight-regular">
          Je vous propose une revue sur toutes les coupes du monde de
          <v-chip color="red white--text font-weight-bold">1930</v-chip>
          à
          <v-chip color="red white--text font-weight-bold">2022</v-chip>.
          <br />Pour des propositions d'améliorations n'hesitez pas à me
          contacter via les réseaux sociaux. Les liens sont juste au bas de la
          page.
        </p>
      </v-col>
    </v-row>

    <h2 class="text-center font-weight-bold mb-2">
      Un peu de visualisation
      <v-icon color="purple lighten-1">mdi-chart-line</v-icon>
    </h2>

    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-card class="mt-10 mx-auto" max-width="600">
          <v-sheet
            class="v-sheet--offset mx-auto"
            color="deep-orange accent-3"
            elevation="12"
            max-width="calc(100% - 32px)"
          >
            <v-sparkline
              auto-draw
              :labels="tenLastworldCupsLabels"
              :value="tenLastworldsCupsAttendances"
              color="white"
              line-width="2"
              padding="16"
            ></v-sparkline>
          </v-sheet>

          <v-card-text class="pt-0">
            <div class="text-h6 font-weight-light mb-2">Attendance</div>
            <div class="subheading font-weight-light grey--text">
              Les 10
              <v-chip small class="white--text" color="red">dernieres</v-chip>
              éditions de coupe du monde
            </div>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small color="deep-orange accent-3">
              mdi-calendar
            </v-icon>
            <span class="text-caption grey--text font-weight-light"
              >De
              <v-chip small color=""
                >{{ tenLastworldCupsLabels[0] }} à
                {{ tenLastworldCupsLabels[9] }}</v-chip
              >.</span
            >
          </v-card-text>
        </v-card></v-col
      >

      <v-col cols="12" sm="6" md="6">
        <v-card class="mt-10 mx-auto" max-width="600">
          <v-sheet
            class="v-sheet--offset mx-auto"
            color="deep-orange accent-3"
            elevation="12"
            max-width="calc(100% - 32px)"
          >
            <v-sparkline
              auto-draw
              :labels="tenFirstworldCupsLabels"
              :value="tenFirstworldsCupsAttendances"
              color="white"
              line-width="2"
              padding="16"
            ></v-sparkline>
          </v-sheet>

          <v-card-text class="pt-0">
            <div class="text-h6 font-weight-light mb-2">Attendance</div>
            <div class="subheading font-weight-light grey--text">
              Les 10
              <v-chip small class="white--text" color="red">premieres</v-chip>
              éditions de coupe du monde
            </div>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small color="deep-orange accent-3">
              mdi-calendar
            </v-icon>
            <span class="text-caption grey--text font-weight-light"
              >De
              <v-chip small color=""
                >{{ tenFirstworldCupsLabels[0] }} à
                {{ tenFirstworldCupsLabels[9] }}</v-chip
              >.</span
            >
          </v-card-text>
        </v-card></v-col
      >

      <v-col cols="12" sm="6" md="6">
        <v-card class="mt-10 mx-auto" max-width="600">
          <v-sheet
            class="v-sheet--offset mx-auto"
            color="cyan"
            elevation="12"
            max-width="calc(100% - 32px)"
          >
            <v-sparkline
              :labels="tenLastworldCupsLabels"
              :value="tenLastParticipants"
              color="white"
              line-width="2"
              padding="16"
              auto-draw
            ></v-sparkline>
          </v-sheet>

          <v-card-text class="pt-0">
            <div class="text-h6 font-weight-light mb-2">
              Nombre de participants
            </div>
            <div class="subheading font-weight-light grey--text">
              Les 10
              <v-chip small class="white--text" color="red">dernieres</v-chip>
              éditions de coupe du monde
            </div>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small color="cyan"> mdi-calendar </v-icon>
            <span class="text-caption grey--text font-weight-light"
              >De
              <v-chip small color=""
                >{{ tenLastworldCupsLabels[0] }} à
                {{ tenLastworldCupsLabels[9] }}</v-chip
              >.</span
            >
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-card class="mt-10 mx-auto" max-width="600">
          <v-sheet
            class="v-sheet--offset mx-auto"
            color="cyan"
            elevation="12"
            max-width="calc(100% - 32px)"
          >
            <v-sparkline
              :labels="tenFirstworldCupsLabels"
              :value="tenFirstParticipants"
              color="white"
              line-width="2"
              padding="16"
              auto-draw
            ></v-sparkline>
          </v-sheet>

          <v-card-text class="pt-0">
            <div class="text-h6 font-weight-light mb-2">
              Nombre de participants
            </div>
            <div class="subheading font-weight-light grey--text">
              Les 10
              <v-chip small class="white--text" color="red">premieres</v-chip>
              éditions de coupe du monde
            </div>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small color="cyan"> mdi-calendar </v-icon>
            <span class="text-caption grey--text font-weight-light"
              >De
              <v-chip small color=""
                >{{ tenFirstworldCupsLabels[0] }} à
                {{ tenFirstworldCupsLabels[9] }}</v-chip
              >.</span
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GET_CUPS } from "@/graphql/queries";

export default {
  name: "HelloWo",
  data: () => ({
    loading: "",
    worldCups: [],
    tenFirstworldCupsLabels: [],
    tenLastworldCupsLabels: [],
    tenLastworldsCupsAttendances: [],
    tenFirstworldsCupsAttendances: [],
    tenLastParticipants: [],
    tenFirstParticipants: [],
    participants: [],
    matches: [],
    lastWc: [],
    lastLastWc: [],
  }),
  created() {
    this.$watch(
      "$apollo.loading",
      (loading) => {
        this.loading = loading;
      },
      { immediate: true }
    );
  },
  mounted() {
    this.getWcs();
  },
  methods: {
    async getWcs() {
      await this.$apollo
        .query({
          query: GET_CUPS,
        })
        .then((result) => {
          this.worldCups = result.data.cups;
          for (let index = 0; index < 10; index++) {
            const element = this.worldCups[index];
            this.tenLastworldsCupsAttendances.push(
              parseInt(element.attendance)
            );
            this.tenLastworldCupsLabels.push(parseInt(element.year));
            this.tenLastParticipants.push(parseInt(element.teams));
          }
          for (
            let index = this.worldCups.length - 1;
            index >= this.worldCups.length - 10;
            index--
          ) {
            const element = this.worldCups[index];
            this.tenFirstworldsCupsAttendances.push(
              parseInt(element.attendance)
            );
            this.tenFirstworldCupsLabels.push(parseInt(element.year));
            this.tenFirstParticipants.push(parseInt(element.teams));
          }
        });
    },
  },
};
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
